import { MenuModule } from '../../components/menu/menu.module';
import { ProfileModule } from '../../components/profile/profile.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { from } from 'rxjs';

@NgModule({
    imports: [CommonModule, MenuModule, ProfileModule],
    declarations: [HeaderComponent],
    exports: [HeaderComponent]
})
export class HeaderModule {}
